$sideMenuHeight: 54px;

.SideMenuWrapper {
  height: $sideMenuHeight;
  display: flex;
  align-items: center;
  gap: var(--space-m);
}

.SvpAdminButton {
  background: #fff;
  padding: 0 var(--space-m);
  display: flex;
  align-items: center;
  border: 1px solid var(--color-svp-grey);
  border-radius: var(--border-radius-xs);
  color: var(--color-accent-2);
  font-weight: var(--font-weight-bold);
  text-decoration: none;
  cursor: pointer;

  & img {
    width: var(--space-l);
    margin-right: var(--space-s);
  }

  &:hover {
    border: 1px solid var(--color-accent-2);
  }
}

.streamLogo {
  display: inline-block;
  height: 30px;
  vertical-align: top;
  position: absolute;
  top: 50%;
  left: -10px;
  margin-top: -15px;
}

.streamLink {
  text-decoration: none;
}

.streamLinkLabel {
  position: relative;
  padding-left: 30px;
}
